module.exports = __webpack_public_path__ + "img/vip-3.f93f0c2f.png";